<template>
    <Card :title="$t('labels.custom_fields')">
        <div class="table-responsive">
            <table class="table table-bordered">
                <thead>
                    <tr>
                        <th width="50%">{{ $t('labels.custom_field') }}</th>
                        <th width="50%">{{ $t('labels.value') }}</th>
                        <th width="60px"></th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td>
                            <AppSelect
                                :model-value="customField?.uuid"
                                :selected-value="customField?.name"
                                :selected-values="Object.keys(integrationCustomFields)"
                                @update:model-value="selectCustomField"
                                :options="customFields.map(field => ({ key: field.uuid, value: field.name }))"
                                optionKey="key"
                                optionValue="value"
                            />
                        </td>
                        <td>
                            <Input
                                v-model="customFieldValue"
                            />
                        </td>
                        <td>
                            <AppButton
                                size="sm" 
                                color="light" 
                                class="btn-icon"
                                @click="addCustomFieldValue"
                            >
                                <i class="icon-diff-added"></i>
                            </AppButton>
                        </td>
                    </tr>
                    <tr v-for="(value, key) in integrationCustomFields" :key="key">
                        <td>{{ this.customFields.find(field => field.uuid === key)?.name }}</td>
                        <td>
                            <Input
                                v-model="integrationCustomFields[key]"
                            />
                        </td>
                        <td>
                            <AppButton
                                size="sm"
                                color="light"
                                class="btn-icon"
                                @click="() => {
                                    delete integrationCustomFields[key];
                                }"
                            >
                                <i class="icon-diff-removed"></i>
                            </AppButton>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
        <div class="card-footer d-flex justify-content-end">
            <AppButton color="indigo" @click="saveIntegrationCustomFields">
                {{ $t('buttons.save') }}
            </AppButton>
        </div>
    </Card>
</template>
<script>
import Card from '../../../../components/new/CardComponent.vue';
import Input from '../../../../components/new/form/Input.vue';
import AppSelect from '../../../../components/new/form/select/AppSelect.vue';
import AppButton from '../../../../components/new/button/AppButton.vue';

import { httpClient } from '../../../../services/HttpClient';
import MessageNotificator from '../../../../services/MessageNotificator';

export default {
    name: "IntegrationCustomFieldsSettings",
    components: {
        Card, Input, AppSelect, AppButton
    },
    data() {
        return {
            customField: {},
            customFields: [],
            customFieldValue: null,
            integrationCustomFields: {}
        }
    },
    methods: {
        saveIntegrationCustomFields() {
            let requestBody = Object.entries(this.integrationCustomFields).map(([key, value]) => {
                return {
                    custom_field_uuid: key,
                    key: value
                }
            });

            httpClient.put(`/integrations/${this.$route.params.integrationUuid}/custom-fields`, {
                data: requestBody
            }).then(() => {
                new MessageNotificator().success(this.$t('alerts.success'));
            })
        },
        fetchIntegrationCustomFields() {
            httpClient.get(`/integrations/${this.$route.params.integrationUuid}/custom-fields`, { limit: 100 })
                .then(response => {
                    this.integrationCustomFields = response.data.data.reduce((acc, field) => {
                        acc[field.custom_field_uuid] = field.key;

                        return acc;
                    }, {});
                })
        },
        async fetchCustomFields() {
            await httpClient.get(`/projects/${this.$route.params.projectUuid}/crm/custom-fields`, { limit: 100 })
                .then(response => {
                    this.customFields = response.data.data;
                })
        },
        selectCustomField(customField) {
            this.customField = this.customFields.find(field => field.uuid === customField.key) || {};
            this.customFieldValue = null;
        },
        addCustomFieldValue() {
            this.integrationCustomFields[this.customField.uuid] = this.customFieldValue;
            this.customFieldValue = null;
            this.customField = {};
        }
    },
    async mounted() {
        await this.fetchCustomFields();
        this.fetchIntegrationCustomFields();
    }
}
</script>